import {
  ErrorResponse,
  Issuer,
  IssuerCreationData,
  IssuerUpdateData,
  RequestResponse
} from "../types";
import { axiosInstanceITG } from "../axios";

type GetAllIssuersReturnType = {
  issuers: Issuer[];
  count: number;
};
export const getAllIssuers: (params: {
  pageNumber: number;
  pageSize: number;
}) => Promise<RequestResponse<GetAllIssuersReturnType>> = async params => {
  try {
    const response = await axiosInstanceITG.get("/issuers/paginate", {
      params
    });
    if (response.status !== 200) {
      throw Error(`Request failed with code: ${response.status}`);
    }
    const data = { count: response.data.count, issuers: response.data.data };
    return { error: false, data };
  } catch (error) {
    console.error("Error fetching issuers: ", error);
    return {
      error: true,
      message: error?.response?.data?.errorMessage || error.message,
      data: null
    };
  }
};

export const addIssuer: (data: IssuerCreationData) => Promise<ErrorResponse> =
  async data => {
    try {
      await axiosInstanceITG.post("/issuers/add", data);
      return { error: false };
    } catch (error) {
      console.error("Error creating issuer: ", error);
      return {
        error: true,
        message: error?.response?.data?.errorMessage || error.message,
        data: null
      };
    }
  };

export const updateIssuer: (data: IssuerUpdateData) => Promise<ErrorResponse> =
  async ({ id, ...data }) => {
    try {
      await axiosInstanceITG.put(`/issuers/update/${id}`, data);
      return { error: false };
    } catch (error) {
      console.error("Error updating issuer: ", error);
      return {
        error: true,
        message: error?.response?.data?.errorMessage || error.message,
        data: null
      };
    }
  };

export const getIssuerWithUsername: (
  username: string
) => Promise<RequestResponse<Issuer>> = async username => {
  try {
    const response = await axiosInstanceITG.get("/issuers/get-issuer", {
      params: { username }
    });
    if (response.status !== 200) {
      throw Error(`Request failed with code: ${response.status}`);
    }
    const data = response.data as Issuer;
    return { error: false, data };
  } catch (error) {
    console.error("Error getting issuer with username: ", error);
    return {
      error: true,
      message: error?.response?.data?.errorMessage || error.message,
      data: null
    };
  }
};

export const updateIssuerSecret: (issuerId: string) => Promise<ErrorResponse> =
  async issuerId => {
    try {
      await axiosInstanceITG.post("/issuers/generate-secret", { issuerId });
      return { error: false };
    } catch (error) {
      console.error("Error updating issuer secret: ", error);
      return {
        error: true,
        message: error?.response?.data?.errorMessage || error.message,
        data: null
      };
    }
  };
